<div class="faq-search">
    <input type="text" class="faq-text" placeholder="Ask your Question">
</div>